@if (visible()) {
  <div class="cookie-banner" role="dialog" aria-label="Informativa cookie">
    <div class="cookie-banner-inner">
      <p class="cookie-banner-text">
        Questo sito utilizza cookie e memorizzazioni tecniche necessari al
        funzionamento. Per saperne di più consulta la
        <a [routerLink]="cookiePolicyLink()">Cookie Policy</a>.
      </p>
      <button type="button" class="cookie-banner-btn" (click)="acknowledge()">
        Ho capito
      </button>
    </div>
  </div>
}
